import { GlobalConfig } from 'ngx-toastr';

export const toasterConfig: Partial<GlobalConfig> = {
  tapToDismiss: true,
  preventDuplicates: false,
  timeOut: 5000,
  extendedTimeOut: 1000,
  positionClass: 'toast-top-right',
  closeButton: true,
};
